import { Box, Text } from '@moonpig/launchpad-components'
import { SpacePig, IconSystemTickOutline } from '@moonpig/launchpad-assets'
import { styled } from '@moonpig/launchpad-utils'
import { colorValue, spacing } from '@moonpig/launchpad-theme'
import { system as s } from '@moonpig/launchpad-system'

export const SuccessTickOutline = styled(IconSystemTickOutline)`
  color: ${colorValue('colorFeedbackSuccess')};
  height: ${spacing(10)}px;
  width: ${spacing(10)}px;
`

export const BrandedBenefitsBox = styled(Box)`
  background-color: ${colorValue('colorBackground03')};
  ${s({
    width: { xs: `calc(100% - ${spacing(10)}px)`, md: 2 / 5 },
  })}
`

export const BrandedBenefitText = styled(Text)`
  text-align: left;
  color: ${colorValue('colorTextHeadline')};
`

export const FloatingPig = styled(SpacePig)`
  width: 142px;
  animation: floating-pig 500ms;
  animation-duration: 3000ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;

  @keyframes floating-pig {
    0% {
      transform: translate(0, 0px);
    }
    50% {
      transform: translate(0, 15px);
    }
    100% {
      transform: translate(0, -0px);
    }
  }
`
